import { LitElement, html, css } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';

import '@shoelace-style/shoelace/dist/components/card/card.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';
import '@shoelace-style/shoelace/dist/components/textarea/textarea.js';
import '@shoelace-style/shoelace/dist/components/icon-button/icon-button.js';
import '@shoelace-style/shoelace/dist/components/dialog/dialog.js';
import { SlDialog } from '@shoelace-style/shoelace';

const style = css`
  sl-card {
    width: 100%;
    margin: 1em auto;
  }

  .menuOption [slot='header'] {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }

  .menuOption sl-icon-button {
    font-size: var(--sl-font-size-x-large);
  }

  .price {
    display: flex;
    justify-content: flex-end;
  }

  page.confirmDelete::part(body) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

@customElement('edit-option')
export class EditOption extends LitElement {
  static styles = [style];
  @property({ attribute: 'option-id' }) optionId = '';
  @property() title = '';
  @state() private _titleInput = '';
  @property() desc = '';
  @state() private _descInput = '';
  @property({ type: Number }) price = 0;
  @state() private _priceInput = 0;
  @property({ type: Number }) rank = 0;

  connectedCallback(): void {
    super.connectedCallback();
    this._titleInput = this.title;
    this._descInput = this.desc;
    this._priceInput = this.price;
  }

  inputHandler(e: Event) {
    const key = (e.target as HTMLInputElement).name;

    switch (key) {
      case 'title':
        this._titleInput = (e.target as HTMLInputElement).value as any;
        break;
      case 'desc':
        this._descInput = (e.target as HTMLInputElement).value as any;
        break;
      case 'price':
        this._priceInput = (e.target as HTMLInputElement).value as any;
        break;
    }

    const event = new CustomEvent('value-changed', {
      bubbles: true,
      composed: true,
      detail: {
        rank: this.rank,
        optionId: this.optionId,
        title: this._titleInput,
        desc: this._descInput,
        price: this._priceInput,
      },
    });
    this.dispatchEvent(event);
  }

  moveUp() {
    const event = new CustomEvent('move-up', {
      bubbles: true,
      composed: true,
      detail: {
        optionId: this.optionId,
      },
    });
    this.dispatchEvent(event);
  }

  moveDown() {
    const event = new CustomEvent('move-down', {
      bubbles: true,
      composed: true,
      detail: {
        optionId: this.optionId,
      },
    });
    this.dispatchEvent(event);
  }

  @query('sl-dialog') dialog!: SlDialog;

  trash() {
    this.dialog.show();
  }

  confirmTrash() {
    const event = new CustomEvent('trash', {
      bubbles: true,
      composed: true,
      detail: {
        optionId: this.optionId,
      },
    });
    this.dispatchEvent(event);
    this.dialog.hide();
  }

  render() {
    return html`
      <sl-card class="menuOption">
        <div slot="header">
          <sl-icon-button
            name="trash3"
            label="Trash"
            @click="${this.trash}"
          ></sl-icon-button>
          <sl-icon-button
            name="arrow-up-square"
            label="Move Up"
            @click="${this.moveUp}"
          ></sl-icon-button>
          <sl-icon-button
            name="arrow-down-square"
            label="Move Down"
            @click="${this.moveDown}"
          ></sl-icon-button>
        </div>

        <p>
          <sl-input
            placeholder="Title"
            name="title"
            value="${this._titleInput}"
            @sl-input="${this.inputHandler}"
          ></sl-input>
          <br />
          <sl-textarea
            name="desc"
            placeholder="Description"
            value="${this._descInput}"
            @sl-input="${this.inputHandler}"
          ></sl-textarea>
          <br />
          <sl-input
            name="price"
            class="price"
            type="number"
            placeholder="Price"
            value="${this._priceInput}"
            @sl-input="${this.inputHandler}"
          ></sl-input>
        </p>

        <sl-dialog
          label="Delete Menu Option?"
          style="--width: 50vw;"
          class="confirmDelete"
        >
          <sl-button variant="danger" @click="${this.confirmTrash}"
            >Delete</sl-button
          >
        </sl-dialog>
      </sl-card>
    `;
  }
}
